import { PublicLocation } from "../../../../domain/Profile/schema"

const VIRTUAL = "virtual"

export const getLocationAddresses = (
  location: PublicLocation,
  showFullAddress?: boolean,
) => {
  const address = [location.line1, showFullAddress ? location.line2 : undefined]
    .filter(Boolean)
    .join(", ")
  const cityStateZip = [
    location.city,
    location.stateOrTerritory,
    location.postalCode,
  ]
  const fullCityStateZip = cityStateZip.filter(Boolean).join(", ")

  const locationAddresses =
    location.locationTypeDisplayId !== VIRTUAL
      ? {
          address,
          fullCityStateZip,
        }
      : undefined

  return locationAddresses
}

export const getCombinedAddress = (
  location: PublicLocation,
  virtualText?: string,
  showFullAddress?: boolean,
) => {
  if (location.locationTypeDisplayId === VIRTUAL) {
    return virtualText || "Virtual"
  }
  const locationAddresses = getLocationAddresses(location, showFullAddress)
  const addressWithCityStateZip = [
    locationAddresses?.address,
    locationAddresses?.fullCityStateZip,
  ]
    .filter(Boolean)
    .join(", ")
  return addressWithCityStateZip
}

// order locations alphabetically by the folllowing importance:
// 0) physical locations first
// 1) primary first
// 2) by state alphanumerically
// 3) city alphanumerically
// 4) address line 1 alphanumerically
export function sortLocations(locations: PublicLocation[]): PublicLocation[] {
  return locations.sort((a, b) => {
    // 0. Sort virtual locations to the bottom
    if (
      a.locationTypeDisplayId === VIRTUAL &&
      b.locationTypeDisplayId !== VIRTUAL
    ) {
      return 1
    }
    if (
      a.locationTypeDisplayId !== VIRTUAL &&
      b.locationTypeDisplayId === VIRTUAL
    ) {
      return -1
    }

    // 1. Sort by isPrimary (true comes first)
    if (a.isPrimary !== b.isPrimary) {
      return a.isPrimary ? -1 : 1
    }

    // 2. Sort by stateOrTerritory
    if (a.stateOrTerritory !== b.stateOrTerritory) {
      return (a.stateOrTerritory ?? "").localeCompare(b.stateOrTerritory ?? "")
    }

    // 3. Sort by city
    if (a.city !== b.city) {
      return (a.city ?? "").localeCompare(b.city ?? "")
    }

    // 4. Sort by line1
    return (a.line1 ?? "").localeCompare(b.line1 ?? "")
  })
}
